/* eslint-disable react/no-did-update-set-state */
/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, shape, arrayOf, number } from "prop-types";
import { push } from "react-router-redux";
import { Field, Form, withFormik } from "formik";
import Col from "react-bootstrap/lib/Col";
import { compose } from "redux";
import moment from "moment";
import Yup from "yup";
import classNames from "classnames";

import { actions as checksActions, selectors as checksSelectors } from "reducers/checks";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";

import { DateField } from "pages/_components/fields/DateField";
import TextField from "pages/_components/fields/TextField";
import AmountField from "pages/_components/fields/formik/AmountField";
import PageLoading from "pages/_components/PageLoading";
import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import Pagination from "pages/_components/pagination/Pagination";
import ContextMenu from "pages/_components/ContextMenu";
import I18n from "pages/_components/I18n";
import Hint from "pages/_components/hints/Hint";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import { evalEqualsValues } from "util/form";
import { getPostLoginHomePath } from "util/v3UxConfig";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import RowButtons from "./_components/RowButtons";
import ChecksDetailTable from "./_components/ChecksDetailTable";

const FORM_ID = "checksDetail";
const CHECK_TYPE_PROPIOS = 1;
const CHECK_TYPE_TERCEROS = 2;
const getLimitDate = (dateDif) => {
    const date = moment(new Date()); // the day before DST in the US

    date.add(dateDif, "days");

    return date.toDate();
};

class ChecksDetail extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        fetchingDownload: bool,
        isEmittedSelected: bool.isRequired,
        isDepositedSelected: bool.isRequired,
        values: shape({}).isRequired,
        isDesktop: bool,
        isSmallDesktop: bool,
        listCheckDetail: arrayOf(shape({})).isRequired,
        checkDetailTotalPages: number.isRequired,
        checkDetailCurrentPageNumber: number.isRequired,
        setErrors: func.isRequired,
        setSubmitting: func.isRequired,
        setValues: func.isRequired,
        showForm: bool.isRequired,
        checksFilters: shape({}),
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        fetchingDownload: false,
        checksFilters: {},
        isDesktop: true,
        isSmallDesktop: false,
        embeddedInV3Shell: false,
    };

    state = {
        hasChanged: false,
        activeButton: "emitted.checks",
    };

    componentDidMount = () => {
        const { isEmittedSelected, values, dispatch, setSubmitting } = this.props;
        const { checkNumber, dateFrom, dateTo, dates, amountFrom, amountTo } = values;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        this.setShowForm(false);
        dispatch(
            checksActions.fetchCheckDetailList(
                setSubmitting,
                isEmittedSelected ? CHECK_TYPE_PROPIOS : CHECK_TYPE_TERCEROS,
                "1",
                checkNumber,
                enableRangeDatefield ? dates[0] : dateFrom,
                enableRangeDatefield ? dates[1] : dateTo,
                amountFrom,
                amountTo,
            ),
        );
        this.applyV3ShellLayout();
    };

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        const home = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["checksMain", "checksDetail"],
            titleKey: `${FORM_ID}.header.title`,
            goBackPath: home,
            rightContentMobile: !isDesktop ? this.rightContent() : undefined,
        });
    };

    componentDidUpdate = (prevProps) => {
        const { values } = this.props;
        const { amountFrom, amountTo, checkNumber } = values;
        const { hasChanged } = this.state;
        if (
            amountFrom !== prevProps.values.amountFrom ||
            amountTo !== prevProps.values.amountTo ||
            checkNumber !== prevProps.values.checkNumber
        ) {
            if ((amountFrom !== "" || amountTo !== "" || checkNumber !== "") && !hasChanged) {
                this.setState({ hasChanged: true });
            } else if ((amountFrom === "" || amountTo === "" || checkNumber === "") && hasChanged) {
                this.setState({ hasChanged: false });
            }
        }
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop) {
            this.applyV3ShellLayout();
        }
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push(getPostLoginHomePath(isUxDashboardImprovementsEnabled())));
        } else {
            dispatch(push("/desktop"));
        }
    };

    handleExport = (format) => {
        const isMVP4ReportsEnabled = configUtils.getBoolean("frontend.showReportesMVP4.funcionalities", false);
        const {
            dispatch,
            values,
            isEmittedSelected,
            listCheckDetail,
            checkDetailCurrentPageNumber,
            checkDetailTotalPages,
        } = this.props;
        const { checkNumber, dateFrom, dateTo, dates, amountFrom, amountTo } = values;
        const registersByPage = isMVP4ReportsEnabled
            ? listCheckDetail.length * checkDetailTotalPages
            : listCheckDetail.length + 1;
        const pageNumber = isMVP4ReportsEnabled ? "1" : checkDetailCurrentPageNumber;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        dispatch(
            checksActions.downloadCheckDetail(
                format,
                isEmittedSelected ? CHECK_TYPE_PROPIOS : CHECK_TYPE_TERCEROS,
                pageNumber,
                checkNumber,
                enableRangeDatefield ? dates[0] : dateFrom,
                enableRangeDatefield ? dates[1] : dateTo,
                amountFrom,
                amountTo,
                registersByPage,
            ),
        );
    };

    handleChangeButton = (button) => {
        const { dispatch, setSubmitting, setErrors, setValues } = this.props;
        setValues({
            checkNumber: "",
            dateFrom: getLimitDate(-1),
            dateTo: getLimitDate(0),
            dates: [getLimitDate(-1), getLimitDate(0)],
            amountFrom: "",
            amountTo: "",
        });
        setErrors({});
        if (button === "emitted.checks") {
            dispatch(checksActions.setEmmitedChecks());
        } else {
            dispatch(checksActions.setDepositedChecks());
        }

        dispatch(
            checksActions.fetchCheckDetailList(
                setSubmitting,
                button === "emitted.checks" ? CHECK_TYPE_PROPIOS : CHECK_TYPE_TERCEROS,
                "1",
                "",
                getLimitDate(-1),
                getLimitDate(0),
                "",
                "",
            ),
        );
    };

    fetchCheckDetailNextPage = (pageNumber) => {
        const { dispatch, values, setSubmitting, isEmittedSelected } = this.props;
        const { checkNumber, dateFrom, dateTo, dates, amountFrom, amountTo } = values;
        setSubmitting(true);
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        dispatch(
            checksActions.fetchCheckDetailList(
                setSubmitting,
                isEmittedSelected ? CHECK_TYPE_PROPIOS : CHECK_TYPE_TERCEROS,
                pageNumber,
                checkNumber,
                enableRangeDatefield ? dates[0] : dateFrom,
                enableRangeDatefield ? dates[1] : dateTo,
                amountFrom,
                amountTo,
            ),
        );
    };

    getMaxDateFrom = () => {
        const maxDateFrom = configUtils.getInteger("echeq.max.dateFrom", 3);
        const date = new Date();

        return new Date(date.setMonth(date.getMonth() - maxDateFrom));
    };

    renderFirstRowFilter = (isDesktop, isSmallDesktop, dateFrom, isSubmitting, isEmittedSelected) => {
        const { values, checksFilters } = this.props;
        const { activeButton } = this.state;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        let lgCols = 2;
        if (enableRangeDatefield) {
            if (isSmallDesktop) {
                lgCols = 6;
            } else {
                lgCols = 3;
            }
        } else if (isSmallDesktop) {
            lgCols = 4;
        }
        return (
            <div
                className={`flex-grow align-items-center container-white my-2 ${
                    !isDesktop ? "transparent pt-0 mt-0" : "px-2 pt-3 pb-2"
                }`}>
                <Col
                    xs={12}
                    md={enableRangeDatefield ? 6 : 4}
                    lg={lgCols}
                    className={classNames({ "align-self-flex-start px-2 mb-2": isDesktop })}>
                    <Field
                        component={TextField}
                        formGroupTextClassName="mt-1"
                        hidePlaceholder
                        idForm={FORM_ID}
                        name="checkNumber"
                        type="text"
                        pattern="[0-9]*"
                    />
                </Col>
                {enableRangeDatefield ? (
                    <Col
                        xs={12}
                        md={6}
                        lg={isSmallDesktop ? 6 : 3}
                        className={classNames({
                            "align-self-flex-start px-2": isDesktop,
                            "mb-35": !isDesktop,
                        })}>
                        <Field
                            component={RangeDatePicker}
                            idForm={isEmittedSelected ? "checksDetail" : "checksDetail.deposited"}
                            name="dates"
                            required
                            minDate={this.getMaxDateFrom()}
                            maxDate={new Date()}
                        />
                    </Col>
                ) : (
                    <>
                        {!isDesktop && (
                            <div className="w-100 px-3">
                                <I18n
                                    id={
                                        isEmittedSelected
                                            ? "checksDetail.dateDebit.label"
                                            : "checksDetail.dateDeposited.label"
                                    }
                                    component="label"
                                    componentProps={{
                                        className: "control-label mt-2 mb-0",
                                    }}
                                />
                            </div>
                        )}
                        <Col
                            xs={6}
                            md={4}
                            lg={isSmallDesktop ? 4 : 2}
                            className={classNames({
                                "align-self-flex-start px-2": isDesktop,
                            })}>
                            <Field
                                component={DateField}
                                formGroupTextClassName="mt-1 ellipsis-span"
                                hidePlaceholder
                                idForm={isEmittedSelected ? "checksDetail" : "checksDetail.deposited"}
                                name="dateFrom"
                                customKey={!isDesktop && "echeqs.from.label"}
                                selectsStart
                                minDate={this.getMaxDateFrom()}
                                maxDate={moment().add(-1, "days")}
                                autocomplete="off"
                            />
                        </Col>
                        <Col
                            xs={6}
                            md={4}
                            lg={isSmallDesktop ? 4 : 2}
                            className={classNames({
                                "align-self-flex-start px-2": isDesktop,
                            })}>
                            <Field
                                component={DateField}
                                formGroupTextClassName="mt-1 ellipsis-span"
                                hidePlaceholder
                                idForm={isEmittedSelected ? "checksDetail" : "checksDetail.deposited"}
                                name="dateTo"
                                customKey={!isDesktop && "echeqs.to.label"}
                                selectsEnd
                                minDate={dateFrom || this.getMaxDateFrom()}
                                maxDate={moment().add(0, "days")}
                                autocomplete="off"
                            />
                        </Col>
                    </>
                )}
                <Col
                    xs={6}
                    md={4}
                    lg={isSmallDesktop ? 4 : 2}
                    className={classNames({ "align-self-flex-start px-2 mb-2": isDesktop })}>
                    <Field
                        component={AmountField}
                        autocomplete="off"
                        clearable={false}
                        hidePlaceholder
                        maxLength={17}
                        idForm={FORM_ID}
                        name="amountFrom"
                        hideCurrency
                        disableSelect
                        fixedDecimalScale
                        useCustomHandleKeyDown
                        label="transfers.amount.label"
                        inputGroupClassName="mt-1"
                        isFocused
                        plainValue
                    />
                </Col>
                <Col
                    xs={6}
                    md={4}
                    lg={isSmallDesktop ? 4 : 2}
                    className={classNames({ "align-self-flex-start px-2 mb-2": isDesktop })}>
                    <Field
                        component={AmountField}
                        autocomplete="off"
                        clearable={false}
                        hidePlaceholder
                        maxLength={17}
                        idForm={FORM_ID}
                        name="amountTo"
                        hideCurrency
                        disableSelect
                        fixedDecimalScale
                        useCustomHandleKeyDown
                        label="transfers.amount.label"
                        inputGroupClassName="mt-1"
                        isFocused
                        plainValue
                    />
                </Col>
                <Col
                    xs={12}
                    md={4}
                    lg={isSmallDesktop ? 4 : 2}
                    className={classNames("d-flex", {
                        "align-self-flex-start px-2": isDesktop,
                        "checks-search-button": !isDesktop,
                    })}>
                    <Button
                        type="submit"
                        label="echeq.filter"
                        bsStyle="primary"
                        loading={isSubmitting}
                        image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                        imageStyle="mr-2"
                        onClick={() =>
                            this.setState({ activeButton: isEmittedSelected ? "emitted.checks" : "deposited.checks" })
                        }
                        className={classNames("mt-45 mb-0 mr-0 max-height-3", {
                            "text-transform-none": enableNewSubmitButton,
                        })}
                        disabled={
                            enableNewSubmitButton &&
                            evalEqualsValues(
                                {
                                    ...checksFilters,
                                    activeButton,
                                },
                                {
                                    ...values,
                                    activeButton: isEmittedSelected ? "emitted.checks" : "deposited.checks",
                                },
                                [
                                    "activeButton",
                                    ...(!enableRangeDatefield ? ["dates"] : []),
                                    ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                ],
                                [
                                    ...(enableRangeDatefield ? ["dates"] : []),
                                    ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                ],
                            )
                        }
                    />
                </Col>
            </div>
        );
    };

    rightContent = () => {
        const { dispatch, isDesktop } = this.props;

        const options = [
            {
                label: `${FORM_ID}.header.discounted.checks`,
                onClick: () => {
                    dispatch(push("/discountedChecksDetail"));
                    dispatch(checksActions.resetDiscountedFilters());
                },
                icon: "BankSend",
            },
            {
                label: "global.download",
                onClick: () => this.handleExport("pdf"),
                icon: "SendDown",
            },
        ];

        return (
            <ContextMenu
                isDesktop={isDesktop}
                color="white"
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                items={options}
            />
        );
    };

    getHeader = () => {
        const { dispatch, isDesktop, fetchingDownload, listCheckDetail, embeddedInV3Shell } = this.props;

        const isMVP4ReportsEnabled = configUtils.getBoolean("frontend.showReportesMVP4.funcionalities", false);

        if (!isDesktop && embeddedInV3Shell) {
            return null;
        }

        if (isDesktop) {
            return (
                <>
                    <Head onBack={this.handleBack} />
                    <Head
                        title={`${FORM_ID}.header.title`}
                        exportList
                        handleDeleteClick={() => {
                            dispatch(push("/discountedChecksDetail"));
                            dispatch(checksActions.resetDiscountedFilters());
                        }}
                        handleDeleteMessage={`${FORM_ID}.header.discounted.checks`}
                        handleClick={this.handleExport}
                        handleClickMessage="global.download"
                        isFetchingExport={fetchingDownload}
                        headerClassName="checks-header"
                        hasInlineButtons
                        csvDownload
                        exportDisabled={listCheckDetail.length === 0 && !isMVP4ReportsEnabled}
                        titleClassName="no-wrap"
                        messageTooltip="checksDetail.header.hint"
                        alwaysShowMessage
                    />
                </>
            );
        }
        return (
            <Head
                title={`${FORM_ID}.header.title`}
                headerClassName="blue-main-header-mobile blue-main-title-mobile"
                centerContentClassName="mx-5"
                onBack={this.handleBack}
                rightContent={this.rightContent}
            />
        );
    };

    setShowForm = (showForm) => {
        const { dispatch } = this.props;
        dispatch(checksActions.setShowForm(showForm));
    };

    render() {
        const {
            dispatch,
            isEmittedSelected,
            isDepositedSelected,
            values,
            isDesktop,
            isSmallDesktop,
            fetching,
            listCheckDetail,
            checkDetailCurrentPageNumber,
            checkDetailTotalPages,
            showForm,
            embeddedInV3Shell,
        } = this.props;
        const { hasChanged } = this.state;
        const { dateFrom } = values;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        return (
            <>
                {!embeddedInV3Shell && (
                    <>
                        <Notification scopeToShow="checksMain" />
                        <Notification scopeToShow="checksDetail" />
                    </>
                )}
                <div className={classNames("checks_container px-0 mb-0", { "admin-detail-head": isDesktop })}>
                    {this.getHeader()}
                    <RowButtons
                        isButton1Selected={isEmittedSelected}
                        isButton2Selected={isDepositedSelected}
                        FORM_ID={FORM_ID}
                        button1Id="emitted.checks"
                        button2Id="deposited.checks"
                        handleChangeButton={this.handleChangeButton}
                        setShowForm={() => this.setShowForm(!showForm)}
                        showForm={showForm}
                        isDesktop={isDesktop}
                        hasChanged={hasChanged}
                    />
                    {!isDesktop && (
                        <>
                            <Col xs={12} className="mt-2">
                                <Hint
                                    idMessage="checksDetail.header.hint"
                                    classNameGroup="mb-0"
                                    classNameMessage=""
                                    classNameHintP="my-0"
                                    classNameImage="my-0 ml-2 justify-content-center align-self-center"
                                    alwaysShowMessage
                                />
                            </Col>
                            <Col xs={12} className="justify-content-end d-flex">
                                <div className="hide-filter__btn-content pr-0 my-3">
                                    <Button
                                        block
                                        className="hide-filter__btn"
                                        bsStyle="outline"
                                        label={
                                            showForm
                                                ? "global.hide.filter"
                                                : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                        }
                                        image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                        onClick={() => this.setShowForm(!showForm)}
                                    />
                                </div>
                            </Col>
                        </>
                    )}
                    {showForm && (
                        <Form className={enableRangeDatefield ? "checks__form_v2" : undefined}>
                            {this.renderFirstRowFilter(
                                isDesktop,
                                isSmallDesktop,
                                dateFrom,
                                fetching,
                                isEmittedSelected,
                            )}
                        </Form>
                    )}
                    <PageLoading className="line-loader" loading={fetching}>
                        <ChecksDetailTable
                            listCheckDetail={listCheckDetail}
                            isDesktop={isDesktop}
                            tableLabel={FORM_ID}
                            isEmittedSelected={isEmittedSelected}
                            dispatch={dispatch}
                        />
                        {listCheckDetail.length > 0 && (
                            <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
                                <div className="d-flex mt-2">
                                    <Pagination
                                        totalPages={checkDetailTotalPages}
                                        pageNumber={checkDetailCurrentPageNumber}
                                        action={this.fetchCheckDetailNextPage}
                                    />
                                </div>
                            </div>
                        )}
                    </PageLoading>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    isEmittedSelected: checksSelectors.isEmittedSelected(state),
    isDepositedSelected: checksSelectors.isDepositedSelected(state),
    listCheckDetail: checksSelectors.getCheckDetailList(state),
    checkDetailTotalPages: checksSelectors.getCheckDetailTotalPages(state),
    checkDetailCurrentPageNumber: checksSelectors.getCheckDetailCurrentPageNumber(state),
    showForm: checksSelectors.getShowForm(state),
    fetchingDownload: checksSelectors.getFetchingDownload(state),
    checksFilters: checksSelectors.getChecksFilters(state),
    fetching: checksSelectors.getFetching(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: ({ checksFilters }) => ({
            checkNumber: checksFilters?.checkNumber || "",
            dateFrom: checksFilters?.dateFrom || getLimitDate(-1),
            dateTo: checksFilters?.dateTo || getLimitDate(0),
            dates: [checksFilters?.dateFrom || getLimitDate(-1), checksFilters?.dateTo || getLimitDate(0)],
            amountFrom: checksFilters?.amountFrom || "",
            amountTo: checksFilters?.amountTo || "",
        }),
        validationSchema: () => {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            return Yup.lazy((values) =>
                Yup.object().shape({
                    dateFrom: values.dateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.dateTo, i18nUtils.get(`${FORM_ID}.dateFrom.error`))
                        : Yup.date().nullable(),
                    dateTo: values.dateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.dateFrom, i18nUtils.get(`${FORM_ID}.dateTo.error`))
                        : Yup.date().nullable(),
                    checkNumber: values.checkNumber
                        ? Yup.string().matches(/^[0-9]*$/, i18nUtils.get("services.payment.field.isNotNumeric"))
                        : Yup.string().nullable(),
                    amountFrom: Yup.number()
                        .nullable()
                        .typeError(i18nUtils.get(`${FORM_ID}.amount.amountFrom.required`))
                        .max(Yup.ref("amountTo"), i18nUtils.get(`${FORM_ID}.amount.amountFrom.error`)),

                    amountTo: Yup.number()
                        .nullable()
                        .typeError(i18nUtils.get(`${FORM_ID}.amount.amountTo.required`))
                        .min(Yup.ref("amountFrom"), i18nUtils.get(`${FORM_ID}.amount.amountTo.error`)),
                    ...(enableRangeDatefield && {
                        dates: Yup.mixed().test(
                            "dates",
                            i18nUtils.get(`${FORM_ID}.validation.range.date`),
                            ([from, to]) => from && to,
                        ),
                    }),
                }),
            );
        },
        handleSubmit: ({ checkNumber, dateFrom, dateTo, dates, amountFrom, amountTo }, formikBag) => {
            const { dispatch, isEmittedSelected } = formikBag.props;
            const { setSubmitting } = formikBag;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            dispatch(
                checksActions.fetchCheckDetailList(
                    setSubmitting,
                    isEmittedSelected ? CHECK_TYPE_PROPIOS : CHECK_TYPE_TERCEROS,
                    "1",
                    checkNumber,
                    enableRangeDatefield ? dates[0] : dateFrom,
                    enableRangeDatefield ? dates[1] : dateTo,
                    amountFrom,
                    amountTo,
                ),
            );
        },
    }),
    resizableRoute,
)(ChecksDetail);
